<template>
    <div class="main-section">
        <!-- Tab Navigation -->
        <div class="tab-navigation">
            <button v-for="(tab, index) in tabs" :key="index" @click="activeTab = index" :class="['tab-button', { active: activeTab === index }]">
                {{ tab.name }}
            </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">
            <!-- Features Tab -->
            <div v-show="activeTab === 0" class="tab-panel">
                <div class="features-layout">
                    <div class="features-left">
                        <h2 class="features-title">Features</h2>
                        <p class="features-subtitle">Delivering Quality And Reliability, Again And Again</p>
                        <button class="btn-customize" @click="scrollToInquiry">Customize Now</button>
                    </div>
                    <div class="features-right">
                        <div class="article-content-detail" v-html="article.content"></div>
                        <div class="flex gap-1 mt-[60px]">
                            <p class="leading-[40px] font-bold text-[16px] text-[#059669]">Share:</p>
                            <SocialShare network="facebook" :url="currentUrl" :image="shareImageUrl" :styled="true" class="features-right-social-item" />
                            <SocialShare network="linkedin" :url="currentUrl" :image="shareImageUrl" :styled="true" class="features-right-social-item" />
                            <SocialShare network="twitter" :url="currentUrl" :image="shareImageUrl" :styled="true" class="features-right-social-item" />
                            <SocialShare network="whatsapp" :url="currentUrl" :image="shareImageUrl" :styled="true" class="features-right-social-item" />
                            <SocialShare network="telegram" :url="currentUrl" :image="shareImageUrl" :styled="true" class="features-right-social-item" />
                            <SocialShare network="pinterest" :url="currentUrl" :image="shareImageUrl" :styled="true" class="features-right-social-item" />
                            <SocialShare network="reddit" :url="currentUrl" :image="shareImageUrl" :styled="true" class="features-right-social-item" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Why LeaflyPackaging Tab -->
            <div v-show="activeTab === 1" class="tab-panel">
                <div class="why-leafly-section">
                    <h2 class="section-title">Why LeaflyPackaging</h2>
                    <p class="section-subtitle">We're a real factory specializing in serving high-demand clients with vision. Beyond packaging, we're here to grow your brand—past, present, and future</p>

                    <div class="certifications">
                        <h3 class="cert-title">Certified. Sustainable. Visionary</h3>
                        <div class="stats-grid">
                            <div class="stat-item">
                                <div class="stat-number">14</div>
                                <div class="stat-label">Years</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">25,000</div>
                                <div class="stat-label">Square meters</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">80+</div>
                                <div class="stat-label">Advanced Machines</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">17</div>
                                <div class="stat-label">High-Precision Testing Instruments</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">150+</div>
                                <div class="stat-label">Clients</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">15+</div>
                                <div class="stat-label">Publicly Listed Clients</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">2</div>
                                <div class="stat-label">Design studios</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">400+</div>
                                <div class="stat-label">Employees</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">60%</div>
                                <div class="stat-label">Female Employees</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">100%</div>
                                <div class="stat-label">Certified Sustainable Materials</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">15+</div>
                                <div class="stat-label">Supply chains</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">$30M+</div>
                                <div class="stat-label">Revenue</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Custom Process Tab -->
            <div v-show="activeTab === 2" class="tab-panel">
                <div class="custom-process-section">
                    <h2 class="section-title">Custom Process</h2>
                    <div class="process-steps">
                        <div class="process-step">
                            <div class="step-number">1</div>
                            <div class="step-content">
                                <h3 class="step-title">Consultation</h3>
                                <p class="step-desc">Let's Talk About Your Custom Packaging Goals</p>
                                <p class="step-detail">Whether you need custom shipping boxes or custom made boxes for luxury retail in Europe, the U.S., Australia and beyond, our team helps you find the right solution.</p>
                            </div>
                        </div>
                        <div class="process-step">
                            <div class="step-number">2</div>
                            <div class="step-content">
                                <h3 class="step-title">Custom Box Structural Design</h3>
                                <p class="step-desc">Design That Protects & Impresses</p>
                                <p class="step-detail">Our engineers craft functional and beautiful custom product boxes tailored to your needs.</p>
                            </div>
                        </div>
                        <div class="process-step">
                            <div class="step-number">3</div>
                            <div class="step-content">
                                <h3 class="step-title">Box Material Selection</h3>
                                <p class="step-desc">Select materials from kraft to luxury board for impressive packaging</p>
                                <p class="step-detail">We recommend the best material based on your branding and budget – whether it's for magnetic box packaging, custom perfume boxes, or premium packaging box sets.</p>
                            </div>
                        </div>
                        <div class="process-step">
                            <div class="step-number">4</div>
                            <div class="step-content">
                                <h3 class="step-title">Artwork & Dieline Support</h3>
                                <p class="step-desc">Need help?</p>
                                <p class="step-detail">Already have your artwork for custom printed corrugated boxes or magnetic gift boxes? We help you finalize dielines and get print-ready with no stress.</p>
                            </div>
                        </div>
                        <div class="process-step">
                            <div class="step-number">5</div>
                            <div class="step-content">
                                <h3 class="step-title">Box Finishing Touches</h3>
                                <p class="step-desc">Our team will help you choose the right printing and finishing techniques to elevate your custom boxes with logo into a memorable brand experience.</p>
                                <p class="step-detail">Add your brand's personality with: Custom logos, Foil stamping, UV coating, Embossing & debossing</p>
                            </div>
                        </div>
                        <div class="process-step">
                            <div class="step-number">6</div>
                            <div class="step-content">
                                <h3 class="step-title">Sampling & Production</h3>
                                <p class="step-desc">Test It. Love It. Then Go Big.</p>
                                <p class="step-detail">We'll create physical samples to ensure your box is perfect before we move into full production. From small MOQs (1,000 pcs) to high-volume runs – we've got you covered.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- FAQ Tab -->
            <div v-show="activeTab === 3" class="tab-panel">
                <div class="faq-section">
                    <h2 class="section-title">FAQ</h2>
                    <p class="section-subtitle">Don't hesitate to reach out if you have any questions</p>
                    <div class="faq-list">
                        <div class="faq-item" v-for="(faq, index) in faqs" :key="index">
                            <div class="faq-question" @click="toggleFaq(index)">
                                <h3>{{ faq.question }}</h3>
                                <span class="faq-icon" :class="{ active: faq.isOpen }">+</span>
                            </div>
                            <div class="faq-answer" v-show="faq.isOpen">
                                <div v-html="faq.answer"></div>
                            </div>
                        </div>
                    </div>
                    <button class="btn-customize" @click="scrollToInquiry">Customize Now</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts" name="PackagingTabDetail">
    import { ref, computed } from 'vue'
    import type { Article } from '~/types';

    const props = defineProps<{
        article: Article
    }>()

    // 获取当前页面的完整 URL
    const currentUrl = computed(() => {
        if (import.meta.client) {
            // 客户端：使用 window.location.href
            return window.location.href
        } else {
            // 服务端：使用 useRequestURL 获取完整 URL
            const requestURL = useRequestURL()
            return requestURL.href
        }
    })

    // 获取文章图片 URL（用于社交分享）
    const shareImageUrl = computed(() => {
        if (!props.article.imageUrl) {
            return ''
        }
        // 如果已经是完整 URL，直接返回
        if (props.article.imageUrl.startsWith('http://') || props.article.imageUrl.startsWith('https://')) {
            return props.article.imageUrl
        }
        // 如果是相对路径，转换为绝对 URL
        if (import.meta.client) {
            return new URL(props.article.imageUrl, window.location.origin).href
        } else {
            const requestURL = useRequestURL()
            return new URL(props.article.imageUrl, requestURL.origin).href
        }
    })

    // Tab management
    const activeTab = ref(0)
    const tabs = [
        { name: 'Features' },
        { name: 'Why LeaflyPackaging' },
        { name: 'Custom Process' },
        { name: 'FAQ' }
    ]

    // FAQ data
    const faqs = ref([
        {
            question: 'How should packaging dimensions be measured?',
            answer: `When measuring packaging dimensions, focus on the product's three main dimensions: length, width, and depth. The method of measurement depends on the type of packaging:<br><br>
            <strong>Rigid & corrugated packaging</strong>: Use internal dimensions to ensure the product fits perfectly inside and provides enough protection.<br><br>
            <strong>Folding cartons & lighter packaging</strong>: While external dimensions are often used, it's recommended to follow industry standards and use internal dimensions to avoid any size mismatch issues.<br><br>
            If you encounter any difficulties in measuring, feel free to contact our sales team for further guidance and assistance.`,
            isOpen: false
        },
        {
            question: 'What accessory options do you offer?',
            answer: 'We offer a wide range of accessory options. If you have specific accessory needs or styles in mind, you can let us know, and our sales team will help you find the perfect match from our robust supply chain.',
            isOpen: false
        },
        {
            question: 'Do you charge for design services?',
            answer: 'We offer basic design services for free, including simple graphic design, structural recommendations, process suggestions, and material recommendations. If you need more advanced design services, we can assign a senior designer to work with you, which will be a paid service.',
            isOpen: false
        },
        {
            question: 'What are your shipping options?',
            answer: `<strong>Shipping Options</strong><br><br>
            We offer sea, air, or courier shipping based on your specific needs. The shipping method will be tailored to your order details and destination.<br><br>
            <strong>Delivery Methods and Timeframe</strong><br>
            <em>Please note: Shipping times and costs may vary depending on the season.</em><br><br>
            <strong>Sea Shipping</strong><br>
            <strong>Free on Board (FOB):</strong> Delivery to the domestic port (Port of Shanghai), 35 days.<br>
            <strong>Cost, Insurance, and Freight (CIF):</strong> Delivery to a foreign port (as required by the customer), 35 days.<br>
            <strong>Delivered Duty Paid (DDP) via Sea:</strong> Door-to-door service, including taxes, 40 days.<br>
            <strong>Delivered Duty Unpaid (DDU) via Sea:</strong> Door-to-door service, excluding taxes, 40 days.<br><br>
            <strong>Air Shipping</strong><br>
            <strong>Delivered Duty Paid (DDP) via Air:</strong> Door-to-door service, including taxes, 15 days.<br>
            <strong>Delivered Duty Unpaid (DDU) via Air:</strong> Door-to-door service, excluding taxes, 15 days.`,
            isOpen: false
        },
        {
            question: 'What payment methods do you accept?',
            answer: 'We currently offer two payment methods: wire transfer and PayPal. We only accept payments made to the three accounts listed on our website.',
            isOpen: false
        },
        {
            question: 'How do you ensure product quality?',
            answer: 'We strictly control the production process, from material selection to final shipment, with thorough quality inspections. We can provide video updates on the manufacturing process, and customers are welcome to conduct video audits of our facilities.',
            isOpen: false
        }
    ])

    const toggleFaq = (index: number) => {
        faqs.value[index]!.isOpen = !faqs.value[index]!.isOpen
    }

    // 滚动到询价表单
    const scrollToInquiry = () => {
        if (import.meta.client) {
            const inquiryElement = document.getElementById('packaging-inquiry')
            if (inquiryElement) {
                inquiryElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    // Main Section with Tabs
    .main-section {
        margin-bottom: 60px;
        .tab-navigation {
            display: flex;
            gap: 0;
            border-bottom: 2px solid #e5e7eb;
            margin-bottom: 40px;
            width:100%;
            overflow-x: auto;
            overflow-y: hidden;
            
            // 隐藏滚动条但保持滚动功能
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE and Edge */
            
            &::-webkit-scrollbar {
                display: none; /* Chrome, Safari, Opera */
            }

            .tab-button {
                padding: 16px 32px;
                background: none;
                border: none;
                font-size: 16px;
                font-weight: 400;
                color: #6b7280;
                cursor: pointer;
                position: relative;
                transition: color 0.3s;
                flex: 1;
                text-align: center;

                &:hover {
                    color: #4CAF50;
                }

                &.active {
                    color: #4CAF50;
                    font-weight: 600;

                    &::after {
                        content: '';
                        position: absolute;
                        bottom: -2px;
                        left: 0;
                        right: 0;
                        height: 3px;
                        background-color: #f59e0b;
                    }
                }
            }
        }

        .tab-content {
            min-height: 340px;
        }

        .tab-panel {
            animation: fadeIn 0.3s ease-in;
        }

        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(10px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
    }

    // Features Tab
    .features-layout {
        display: flex;
        gap: 60px;
        align-items: flex-start;

        @media (max-width: 1024px) {
            flex-direction: column;
            gap: 40px;
        }

        .features-left {
            flex: 0 0 300px;

            @media (max-width: 1024px) {
                flex: 1;
                width: 100%;
                display:none;
            }

            .features-title {
                font-size: 48px;
                font-weight: 600;
                margin-bottom: 16px;
                color: #111827;
            }

            .features-subtitle {
                font-size: 16px;
                color: #6b7280;
                margin-bottom: 32px;
                line-height: 1.6;
            }

            .btn-customize {
                background-color: #06b6d4;
                color: white;
                border: none;
                padding: 14px 32px;
                border-radius: 8px;
                font-size: 16px;
                font-weight: 600;
                cursor: pointer;
                transition: background-color 0.3s;

                &:hover {
                    background-color: #0891b2;
                }
            }
        }
        .features-right {
            position: relative;
            width:100%;

            .features-right-social {
                position: relative;
                bottom: 0;
                flex-wrap: wrap;
                margin-top: 60px;
                @media (max-width: 768px) {
                    position: relative;
                    margin-top: 50px;
                }
            }
        }
    }

    // Why LeaflyPackaging Tab
    .why-leafly-section {
        .section-title {
            font-size: 36px;
            font-weight: 600;
            margin-bottom: 16px;
            color: #111827;
        }

        .section-subtitle {
            font-size: 18px;
            color: #6b7280;
            margin-bottom: 48px;
            line-height: 1.6;
        }

        .certifications {
            .cert-title {
                font-size: 24px;
                font-weight: 600;
                margin-bottom: 32px;
                color: #111827;
            }

            .stats-grid {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                gap: 32px;

                @media (max-width: 768px) {
                    grid-template-columns: repeat(2, 1fr);
                    gap: 24px;
                }

                .stat-item {
                    text-align: center;

                    .stat-number {
                        font-size: 36px;
                        font-weight: 600;
                        color: #4CAF50;
                        margin-bottom: 8px;
                    }

                    .stat-label {
                        font-size: 16px;
                        font-weight: 600;
                        color: #111827;
                        margin-bottom: 4px;
                    }
                }
            }
        }
    }

    // Custom Process Tab
    .custom-process-section {
        .section-title {
            font-size: 36px;
            font-weight: 600;
            margin-bottom: 48px;
            color: #111827;
        }

        .process-steps {
            display: flex;
            flex-direction: column;
            gap: 40px;

            .process-step {
                display: flex;
                gap: 24px;
                align-items: flex-start;

                @media (max-width: 768px) {
                    flex-direction: column;
                    gap: 16px;
                }

                .step-number {
                    flex-shrink: 0;
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    background-color: #4CAF50;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 24px;
                    font-weight: 600;
                }

                .step-content {
                    flex: 1;

                    .step-title {
                        font-size: 24px;
                        font-weight: 600;
                        margin-bottom: 8px;
                        color: #111827;
                    }

                    .step-desc {
                        font-size: 18px;
                        font-weight: 600;
                        color: #4CAF50;
                        margin-bottom: 12px;
                    }

                    .step-detail {
                        font-size: 16px;
                        line-height: 1.7;
                        color: #4b5563;
                    }
                }
            }
        }
    }

    // FAQ Tab
    .faq-section {
        .section-title {
            font-size: 36px;
            font-weight: 600;
            margin-bottom: 16px;
            color: #111827;
        }

        .section-subtitle {
            font-size: 18px;
            color: #6b7280;
            margin-bottom: 40px;
            line-height: 1.6;
        }

        .faq-list {
            margin-bottom: 40px;

            .faq-item {
                border-bottom: 1px solid #e5e7eb;
                margin-bottom: 0;

                .faq-question {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 24px 0;
                    cursor: pointer;
                    transition: color 0.3s;

                    &:hover {
                        color: #4CAF50;
                    }

                    h3 {
                        font-size: 18px;
                        font-weight: 600;
                        color: #111827;
                        flex: 1;
                        margin: 0;
                    }

                    .faq-icon {
                        font-size: 28px;
                        font-weight: 400;
                        color: #6b7280;
                        transition: transform 0.3s, color 0.3s;
                        width: 32px;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;
                        border: 2px solid #e5e7eb;

                        &.active {
                            transform: rotate(45deg);
                            color: #4CAF50;
                            border-color: #4CAF50;
                        }
                    }
                }

                .faq-answer {
                    padding: 0 0 24px 0;
                    color: #4b5563;
                    line-height: 1.8;
                    font-size: 16px;

                    div {
                        padding-left: 0;
                    }
                }
            }
        }

        .btn-customize {
            background-color: #06b6d4;
            color: white;
            border: none;
            padding: 14px 32px;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.3s;

            &:hover {
                background-color: #0891b2;
            }
        }
    }
</style>

